import { Action, Type } from '../modules/templates/templateEditor/editorActions'
import {
  insertItemAt,
  deleteItem,
  updateItem,
  reorderItem,
} from '../modules/templates/templateEditor/editorHelper'
import { TemplateData } from '../modules/templates/types/blueprint'

import generateTemplateIds from '@/modules/templates/templateRenderer/utils/generateTemplateIds'

export type EditorState = {
  template: TemplateData
  editingItem: {
    type: Type
    id: string
    autoOpenType?: boolean
  }
}

export const reducer = (state: EditorState, action: Action): EditorState => {
  const editorState = { ...state }
  const { template } = editorState

  switch (action.type) {
    case 'CLEAR_EDIT': {
      editorState.template = generateTemplateIds(template)
      editorState.editingItem = null
      break
    }
    case 'EDIT_ITEM': {
      const { itemType, id } = action
      editorState.editingItem = { type: itemType, id, autoOpenType: false }
      break
    }
    case 'ADD_ITEM': {
      const {
        itemType,
        id,
        values,
        parentId,
        index,
        autoOpenType = true,
        autoOpen = true,
      } = action

      const newItem = { ...values, id }

      editorState.template = insertItemAt(
        template,
        itemType,
        newItem,
        parentId,
        index
      )
      if (autoOpen) {
        editorState.editingItem = { type: itemType, id, autoOpenType }
      }
      break
    }
    case 'ADD_ITEMS': {
      const { itemType, multipleValues, parentId, index } = action
      multipleValues.forEach((values, dupIndex) => {
        editorState.template = insertItemAt(
          editorState.template,
          itemType,
          values,
          parentId,
          index + dupIndex
        )
      })
      editorState.editingItem = null
      break
    }
    case 'SAVE_ITEM': {
      const { id, itemType, values, continueEditing } = action
      const newValues = { ...values, id }
      editorState.template = updateItem(template, itemType, id, newValues)

      if (!continueEditing) {
        editorState.editingItem = null
      }
      break
    }
    case 'DELETE_ITEM': {
      const { id, itemType } = action
      editorState.template = deleteItem(template, itemType, id)
      editorState.editingItem = null
      break
    }
    case 'REORDER_ITEM': {
      const { id, itemType, parentId, index } = action
      editorState.template = reorderItem(
        template,
        itemType,
        id,
        parentId,
        index
      )
      editorState.editingItem = null
      break
    }
    case 'IMPORT_TEMPLATE': {
      editorState.template = action.template
      break
    }
  }

  return editorState
}
